import i18n from '@/plugins/i18n';
export const forms = [

    {
        type: 'radio',
        name: 'type',
        title: 'Arıza Kayıt Türü',
        default: 'fault',
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {text: 'Arızalı Cihaz Seri No ile', value: 'fault'},
                {text: 'Yeni Cihaz Seri No ile', value: 'new'},
            ],
        },
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        connectField: "type",
        connectFieldValue: ["new"],
        name: 'customer',
        title: 'Müşteri',
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            search: true,
            track: 'ID'
        },
        modal: ['customer_id'],
        data: ['customer_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        connectField: "type",
        connectFieldValue: ["fault"],
        name: 'serialNumber',
        title: 'Arızalı Cihaz Seri No',
        rules: {required: true},
        modal: ['serial_number'],
        data: ['serial_number'],
        additionalButton: false,
        checkBox: false
    },

    {
        type: 'text',
        connectField: "type",
        connectFieldValue: ["new"],
        name: 'newSerialNumber',
        title: 'Yeni Cihaz Seri No',
        rules: {required: true},
        modal: ['new_serial_no'],
        data: ['new_serial_no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'stock_pieces',
        title: 'Yan Ürünler',
        rules: {required: false},
        options: {
            data: [],
            label: 'name',
            track: 'id',
            search: true,
            multiple: true
        },
        modal: ['pieces'],
        data: ['pieces',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'problem',
        title: 'Problem',
        rules: {required: false},
        modal: ['problem'],
        data: ['problem'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'desc',
        title: 'Açıklama',
        rules: {required: false},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/fault.js